import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { RfqLine, RfqLineCreate, RfqLineFilter } from '../data/rfqLine';

export function createRfqLineService(client: AxiosInstance) {
  return createCrudService<RfqLine, RfqLineCreate, RfqLineFilter>(
    client,
    '/purchase/RfqLine',
    'id',
  );
}

export type RfqLineService = CrudService<RfqLine, RfqLineCreate, RfqLineFilter>;
